const PatientImage = ({patient, size = 45}) => {
    const firstName = patient.firstName || "";
    const lastName = patient.lastName || "";
    const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

    const stringToColor = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#';
        for (let i = 0; i < 3; i++) {
            const value = (hash >> (i * 8)) & 0xFF;
            color += (`00${value.toString(16)}`).slice(-2);
        }
        return color;
    };

    const bgColor = stringToColor(firstName + lastName);
    const fontSize = Math.round(size * 0.31);

    return (
        <div style={{padding: '2px', width: `${size}px`, height: `${size}px`, minWidth: `${size}px`, minHeight: `${size}px`, flexShrink: 0, border: "1px solid #CCCCCC", borderRadius: "50%", backgroundColor: '#f1f1f1'}}>
            {patient.photo ? (
                <img src={patient.photo} alt="" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover', display: 'block' }} />
            ) : (
            <div style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                backgroundColor: bgColor,
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: `${fontSize}px`,
            }}>
                {initials}
            </div>
            )}
        </div>
    );
};

export default PatientImage;